export const entity = {
    name: 'Compatibility',
    facets: [{name: 'codeName', nameOptional: false, uniqueName: true, codeValidator: 'trim'}],
    fields: [
        {path: 'type', type: 'CompatibilityType'},
    ],
    filters: [
        {
            name: 'humanOrAnimal',
            isDefault: false,
            query: function (context) {
                return {type: {$in: ['human', 'animal']}}
            }
        },
        {
            name: 'place',
            isDefault: false,
            query: function (context) {
                return {type: 'place'}
            }
        },
    ]
}

export const module_ = {
    object: 'Compatibility',
    tKey: 'mTitle_compatibility',
    defaultSortBy: 'type',
    defaultSortDirection: 'ASC',
    category: {
        path: 'mTitle_animals',
        icon: 'animal'
    },
    viewMap: {
        dt: [
            'code', 'name', 'type'
        ],
        form: [
            'code', 'name', 'type'
        ]
    }
}
